/*
	Load more content with jQuery - May 21, 2013
  (c) 2013 @ElmahdiMahmoud
  https://codepen.io/elmahdim/pen/sGkvH
*/

$(() => {
  $('[loadmore]')
    .slice(0, 6)
    .removeClass('hide');
  $('#loadMore').on('click', function(e) {
    e.preventDefault();
    $('[loadmore]:hidden')
      .slice(0, 6)
      .slideDown()
      .removeClass('hide')
      .fadeIn('slow');
    console.log($('[loadmore]:hidden').length);
    if ($('[loadmore]:hidden').length <= 0) {
      $('#loadMore').fadeOut('slow');
    }
  });
});
